<div [formGroup]="form" class="form flex flex-column flex-justify-content">
	<div class="flex flex-column flex-wrap flex-align-start flex-gap" style="--gap: 16px; --wrap: wrap">
		@if (cpNowIntegrationEnabled) {
		<div class="flex flex-row flex-wrap flex-align-center-start flex-gap" style="--gap: 16px" ngClass="o-grid-3">
			<input-wrapper class="employee-input-wrapper" readonly label="START DATE *">
				<mat-form-field appearance="outline" (click)="startDate.open()">
					<mat-datepicker-toggle data-test="start-date-button" matPrefix [for]="startDate">
						<app-icon
							matDatepickerToggleIcon
							class="icon-offcycle"
							[name]="'calendar_month'"
							[color]="'var(--color-primary-1000)'"
						></app-icon>
					</mat-datepicker-toggle>
					<input
						id="startDate"
						data-test="start-date-input"
						formControlName="startDate"
						matInput
						[matDatepicker]="startDate"
						(focus)="startDate.open()"
					/>
					<mat-datepicker
						#startDate
						(opened)="openDatePicker('employee-start-date')"
						(viewChanged)="datePickerViewChange($event, 'employee-start-date')"
					></mat-datepicker>
				</mat-form-field>
				@if (form.get('startDate')?.touched && form.controls.startDate.errors?.required) {
				<div input-errors>Start date is required.</div>
				} @if (form.hasError('dateOrder')) {
				<div input-errors>Date cannot be after end date.</div>
				}
			</input-wrapper>

			<input-wrapper label="END DATE" readonly class="employee-input-wrapper">
				<mat-form-field appearance="outline" (click)="endDate.open()">
					<mat-datepicker-toggle data-test="end-date-button" matPrefix [for]="endDate">
						<app-icon
							matDatepickerToggleIcon
							class="icon-offcycle"
							[name]="'calendar_month'"
							[color]="'var(--color-primary-1000)'"
						></app-icon>
					</mat-datepicker-toggle>
					<input
						id="endDate"
						data-test="end-date-input"
						formControlName="endDate"
						matInput
						[matDatepicker]="endDate"
						(focus)="endDate.open()"
					/>
					<mat-datepicker
						#endDate
						(opened)="openDatePicker('employee-end-date')"
						(viewChanged)="datePickerViewChange($event, 'employee-end-date')"
					></mat-datepicker>
				</mat-form-field>

				@if (form.get('endDate')?.touched && form.controls.endDate.errors?.required) {
				<div input-errors>End date is required.</div>
				} @if (form.hasError('dateOrder')) {
				<div input-errors>Date cannot be before start date.</div>
				}
			</input-wrapper>
		</div>
		}
		<div class="flex flex-row flex-wrap flex-align-center-start flex-gap" style="--gap: 16px" ngClass="o-grid-3">
			<input-wrapper label="Employee ID *" class="employee-input-wrapper">
				<input
					data-test="employee-id-input"
					type="text"
					id="employeeId"
					placeholder="Employee ID"
					formControlName="externalId"
				/>
				@if (form.get('externalId')?.touched && form.get('externalId')?.errors?.required) {
				<div input-errors>Employee ID is required</div>
				}
			</input-wrapper>
			<input-wrapper label="First Name *" class="employee-input-wrapper">
				<input
					data-test="first-name-input"
					type="text"
					id="firstName"
					placeholder="First Name"
					formControlName="firstName"
				/>
				@if(form.get('firstName')?.touched) {
				<div input-errors>
					@if(form.get('firstName')?.errors?.required) {
					<ng-container> First Name is required </ng-container>
					} @if(!form.get('firstName')?.errors?.required && form.get('firstName')?.errors?.maxlength) {
					<ng-container>
						Max length is {{ form.controls["firstName"].errors?.maxlength.requiredLength }}
					</ng-container>
					} @if(!form.get('firstName')?.errors?.required && !form.get('firstName')?.errors?.maxlength &&
					form.get('firstName')?.errors?.pattern) {
					<ng-container> Please enter a valid first name. </ng-container>
					}
				</div>
				}
			</input-wrapper>
			<input-wrapper label="Last Name *" class="employee-input-wrapper">
				<input
					data-test="last-name-input"
					type="text"
					id="lastName"
					placeholder="Last Name"
					formControlName="lastName"
				/>
				@if(form.get('lastName')?.touched) {
				<div input-errors>
					@if(form.get('lastName')?.errors?.required) {
					<ng-container> Last Name is required </ng-container>
					} @if(!form.get('lastName')?.errors?.required && form.get('lastName')?.errors?.maxlength) {
					<ng-container>
						Max length is {{ form.controls["lastName"].errors?.maxlength.requiredLength }}
					</ng-container>
					} @if(!form.get('lastName')?.errors?.required && !form.get('lastName')?.errors?.maxlength &&
					form.get('lastName')?.errors?.pattern) {
					<ng-container> Please enter a valid last name. </ng-container>
					}
				</div>
				}
			</input-wrapper>
		</div>
		<div class="flex flex-row flex-wrap flex-align-center-start flex-gap" style="--gap: 16px" ngClass="o-grid-3">
			@if(cpNowIntegrationEnabled && paygroupCPNowToggleOn) {
			<input-wrapper class="employee-input-wrapper" label="Email">
				<input data-test="email-input" type="text" placeholder="Email" formControlName="email" />
				@if((form.get('email')?.touched || form.get('email')?.touched) && form.get('email')?.errors?.required) {
				<div input-errors>Employee email is required.</div>
				} @if((form.get('email')?.touched || form.get('email')?.touched) && form.get('email')?.errors?.email) {
				<div input-errors>Please enter a valid e-mail format.</div>
				}
			</input-wrapper>
			}

			<input-wrapper label="Entity Reference" class="employee-input-wrapper" id="entity-reference">
				<input
					type="text"
					id="enityReference"
					data-test="entity-reference-input"
					placeholder="Entity Reference"
					formControlName="enityReference"
				/>
				<span class="add-config flex flex-align-end"> </span>
			</input-wrapper>

			<input-wrapper label="PayGroup ID" class="employee-input-wrapper">
				<input data-test="payroll-id-input" type="text" id="payRollId" formControlName="payGroupExternalId" />

				<ng-template [appUserRolePermissions] [action]="'hide'" [roles]="['TS_VO', 'CLIENT']">
					<span id="changePayGroup" (click)="onChangePayGroup()" class="add-config flex-align-start-end">
						<mat-icon class="select-icon">add</mat-icon>
						<span class="flex-align-center">Change PG</span>
					</span>
				</ng-template>
			</input-wrapper>
		</div>
		@if(cpNowIntegrationEnabled && paygroupCPNowToggleOn) {
		<div class="flex flex-row flex-wrap flex-align-center-start flex-gap" style="--gap: 16px" ngClass="o-grid-3">
			<input-wrapper label="Contract Type" class="employee-input-wrapper">
				<mat-form-field class="select-contract-type" appearance="outline">
					<mat-select
						id="contractType"
						data-test="contract-type-input"
						class="options-dropdown"
						formControlName="contractType"
						(selectionChange)="onContractTypeChange($event)"
					>
						@for (contractType of contractTypes | keyvalue; track contractType.key) {
						<mat-option [value]="contractType.key">
							{{ contractType.value }}
						</mat-option>
						}
					</mat-select>
					<mat-select-trigger data-test="contract-type-button" class="drop-down-trigger">
						<app-icon
							id="drop-down-arrow-select"
							[color]="'rgba(0, 0, 0, 0.54)'"
							[lineWidth]="'2.5'"
							[name]="'arrow-down'"
							[size]="'16'"
						></app-icon>
					</mat-select-trigger>
				</mat-form-field>
			</input-wrapper>
			@if (form.get('contractType')?.value === 'SB' && form.contains('netSalary')) {
			<!-- Salary Based -->
			<input-wrapper class="employee-input-wrapper" [label]="'Pay Cycle Net Salary (' + formCurrency + ')'">
				<input data-test="net-salary-input" type="number" placeholder="0" formControlName="netSalary" />
				@if(form.get('netSalary')?.touched) {
				<div input-errors>
					@if(form.get('netSalary')?.errors?.required) {
					<ng-container> Pay cycle net salary is required </ng-container>
					} @if(form.get('netSalary')?.errors?.invalidNumber){
					<ng-container> Use only numbers </ng-container>
					}
				</div>
				}
			</input-wrapper>
			} @if (form.get('contractType')?.value === 'HR' && form.contains('hourlyRate')) {
			<input-wrapper class="employee-input-wrapper" [label]="'Hourly Rate (' + formCurrency + ')'">
				<input data-test="hourly-rate-input" type="number" placeholder="0" formControlName="hourlyRate" />
				@if(form.get('hourlyRate')?.touched) {
				<div input-errors>
					@if(form.get('hourlyRate')?.errors?.required) {
					<ng-container>Hourly rate is required </ng-container>
					} @if(form.get('hourlyRate')?.errors?.invalidNumber){
					<ng-container> Use only numbers </ng-container>
					}
				</div>
				}
			</input-wrapper>
			}

			<input-wrapper label="Filler" class="employee-input-wrapper filler">
				<input type="text" />
			</input-wrapper>
		</div>
		}
	</div>

	<div class="btn-container">
		<button
			id="cancel"
			data-test="cancel-button"
			class="cancel-btn"
			(click)="cancel()"
			action-buttons
			mat-stroked-button
		>
			Cancel
		</button>
		@if(!isDisabled) {
		<button
			id="submit"
			data-test="submit-button"
			class="submit-btn"
			(click)="storePayElective()"
			action-buttons
			mat-flat-button
			[disabled]="!form.valid || form.pristine"
		>
			{{ isEdit ? "Update" : "Save" }}
		</button>
		}
	</div>
</div>
